import React from "react";
import { Button } from "react-bootstrap";
import CreateEmployeeModal from "./employeePage/CreateEmployeeModal";
import EmployeesList from "./employeePage/EmployeesList";
import useEmployeePageController from "./employeePage/useEmployeePageController";

export default function EmployeePage() {
  const {
    t,
    employees,
    loading,
    canAddEmployee,
    showCreate,
    creating,
    createErr,
    createForm,
    translateRole,
    openCreate,
    closeCreate,
    handleCreateChange,
    handleCreateEmployee,
    handleEmployeeClick
  } = useEmployeePageController();

  return (
    <div>
      <div className="container d-xl-block">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h1 className="mb-0">{t("employeeTitle")}</h1>
          {canAddEmployee && (
            <Button variant="success" onClick={openCreate}>
              + {t("addEmployee")}
            </Button>
          )}
        </div>

          <EmployeesList
            loading={loading}
            employees={employees}
            t={t}
            translateRole={translateRole}
            onEmployeeClick={handleEmployeeClick}
          />

        <CreateEmployeeModal
          show={showCreate}
          creating={creating}
          error={createErr}
          form={createForm}
          t={t}
          onClose={closeCreate}
          onChange={handleCreateChange}
          onSubmit={handleCreateEmployee}
        />
      </div>
    </div>
  );
}
